import defaultSiteLogoAsset from '@/assets/images/rrpl-logo.png';

export const DEFAULT_SITE_LOGO = defaultSiteLogoAsset;

export { defaultSiteLogoAsset as defaultSiteLogo };
